import { Pipe, PipeTransform } from '@angular/core';
import { SectionColumnCannabinoidType } from '../../../../../models/enum/shared/section-column-cannabinoid-type';
import { SectionColumnType } from '../../../../../models/enum/shared/section-column-type';

@Pipe({
  name: 'isCannabinoidColumn',
  standalone: true
})
export class IsCannabinoidColumnPipe implements PipeTransform {
  transform(columnType: SectionColumnType): keyof typeof SectionColumnCannabinoidType | null {
    const isCannabinoid = Object.values(SectionColumnCannabinoidType).includes(
      columnType as keyof typeof SectionColumnCannabinoidType
    );
    return isCannabinoid ? (columnType as keyof typeof SectionColumnCannabinoidType) : null;
  }
}
